import cx from "classnames";
import { DATE_ASC, DATE_DESC } from "@/constants/schedule";
import { Maybe } from "@/graphql/gql/graphql";
import { getFormattedMonthWeekday } from "@/utils/date";
import { useScheduledGamesFilter } from "@/utils/hooks/useScheduledGamesFilter";
import { DayWeekStringClient } from "../GameInfo/TimeStringClient";
import styles from "./styles.module.scss";

interface DateHeadingProps {
  currentGameTime?: Maybe<string>;
  previousGameTime?: Maybe<string>;
}

export default function DateHeading({
  currentGameTime,
  previousGameTime,
}: DateHeadingProps) {
  const filter = useScheduledGamesFilter();
  if (!currentGameTime) return null;
  if (filter?.sortBy && ![DATE_DESC, DATE_ASC].includes(filter?.sortBy)) {
    return null;
  }

  const currentDate = getFormattedMonthWeekday(currentGameTime);
  const previousDate = previousGameTime
    ? getFormattedMonthWeekday(previousGameTime)
    : null;

  return (
    <p
      suppressHydrationWarning
      data-testid={currentDate === previousDate && "hide-date"}
      className={cx([
        styles.heading,
        currentDate === previousDate && styles.hide,
      ])}
    >
      <DayWeekStringClient isoString={currentGameTime} />
    </p>
  );
}
